import CustomField from "components/common/CustomField";
import { sendNotificationSchema } from "components/common/Validation";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { sendNotification } from "store/actions/notificationSlice";
import { showAlert } from "store/reducers/alertReducer";
import { notificationTypes } from "components/constants/StatusKeys";
import SingleSelect from "components/common/SingleSelect";
import { userRoleType } from "components/constants/DropdownOptions";
import { MultiSelect } from "primereact/multiselect";
import { getCustomerDropdownList } from "store/actions/customerSlice";
import CustomLabel from "components/common/CustomLabel";

const initialValues = {
  title: "",
  titleAr: "",
  description: "",
  descriptionAr: "",
  type: "all",
  isScheduled: false,
  scheduledTime: "",
  customers: [],
  days: 0,
  count: 0,
  roleType: 0,
};

const SendNotification = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.Notifications);
  const [selectedtype, setSelectedType] = useState("all");
  const { customersList } = useSelector((state) => state.Customers);

  useEffect(() => {
    dispatch(getCustomerDropdownList({ keyword: "" }));
  }, []);

  const handleCustomerSearch = (keyword) => {
    dispatch(getCustomerDropdownList({ keyword }));
  };

  const handleOnSubmit = (values) => {
    const {
      title,
      titleAr,
      description,
      descriptionAr,
      type,
      isScheduled,
      scheduledTime,
      customers,
      days,
      count,
      roleType,
    } = values || {};

    const meta = {};

    // Add meta conditionally according to type
    if (type === "customer_type" && roleType > 0) {
      meta.roleType = roleType;
      meta.days = 0;
      meta.count = 0;
    }

    if (type === "last_booking" && days > 0) {
      meta.days = days;
      meta.roleType = 0;
      meta.count = 0;
    }

    if (
      (type === "number_of_bookings" || type === "number_of_workshop_booked") &&
      count > 0
    ) {
      meta.count = count;
      meta.roleType = 0;
      meta.days = 0;
    }

    const payload = {
      type: type, // all,specific-customers
      ...(Object.keys(meta).length > 0 && { meta }), // only add meta if not empty
      customers: customers,
      title: {
        en: title,
        ar: titleAr,
      },
      body: {
        en: description,
        ar: descriptionAr,
      },
      lang: "en",
      // isScheduled,
      // scheduledTime: isScheduled ? scheduledTime : "",
    };

    dispatch(sendNotification(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };
  return (
    <div className="mt-2">
      <Formik
        initialValues={initialValues}
        validationSchema={sendNotificationSchema}
        onSubmit={handleOnSubmit}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            <div className="common_wrapper">
              <Row>
                <Col lg={6}>
                  <div className="form_field">
                    <CustomLabel htmlFor="type" label={t("Select Type")} />
                    <SingleSelect
                      options={notificationTypes}
                      value={values.type}
                      placeholder={t("Select Type")}
                      handleSingleSelectChange={(e) => {
                        setFieldValue("type", e.value);
                        setSelectedType(e.value);
                      }}
                      className={`${
                        errors.type && touched.type ? "invalid" : ""
                      }`}
                      error={errors?.type}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  {selectedtype == "customer_type" && (
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="roleType"
                        label={t("Select Role Type")}
                      />
                      <SingleSelect
                        options={userRoleType}
                        value={values.roleType}
                        placeholder={t("Select Type")}
                        handleSingleSelectChange={(e) => {
                          setFieldValue("roleType", e.value);
                        }}
                        className={`${
                          errors.roleType && touched.roleType ? "invalid" : ""
                        }`}
                        error={errors?.roleType}
                      />
                    </div>
                  )}

                  {selectedtype == "last_booking" && (
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="days"
                        label={t("Last Booking (In Days)")}
                      />
                      <CustomField
                        name={`days`}
                        type="number"
                        placeholder={t("Enter Numbers in Days ")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  )}

                  {selectedtype == "number_of_bookings" && (
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="count"
                        label={t("Number of Bookings")}
                      />
                      <CustomField
                        name={`count`}
                        type="number"
                        placeholder={t("Enter Booking Count")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  )}

                  {selectedtype == "number_of_workshop_booked" && (
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="count"
                        label={t("Number of Workshop Bookings")}
                      />
                      <CustomField
                        name={`count`}
                        type="number"
                        placeholder={t("Enter Booked Workshops Count")}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  )}

                  {selectedtype == "specific_customers" && (
                    <div className="form_field">
                      <CustomLabel
                        htmlFor="count"
                        label={t("Select Customers")}
                      />
                      <MultiSelect
                        value={values.customers}
                        onChange={(e) => {
                          setFieldValue("customers", e.value);
                        }}
                        options={customersList?.map((item) => ({
                          name: `${item?.phone} - ${item?.name}`,
                          value: item?._id,
                        }))}
                        optionLabel="name"
                        display="chip"
                        placeholder={"Specific Customers"}
                        selectAllLabel={t("Select All")}
                        filter
                        filterPlaceholder={t("Search by name, phone number")}
                        onFilter={(e) => handleCustomerSearch(e.filter)}
                        className={`w-100 custom_multi_select ${
                          errors.customers && touched.customers ? "invalid" : ""
                        }`}
                        error={errors?.customers}
                      />
                    </div>
                  )}
                </Col>

                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      name={`title`}
                      type="text"
                      placeholder={t("Enter Title")}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      name={`titleAr`}
                      type="text"
                      placeholder={t("ادخل عنوان")}
                      isArabic={true}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      name={`description`}
                      placeholder="Enter Description"
                      as="textarea"
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      name={`descriptionAr`}
                      placeholder="ادخل وصف"
                      as="textarea"
                      isArabic={true}
                      touched={touched}
                      errors={errors}
                    />
                  </div>
                </Col>
                {/* <Col lg={6}>
                  <div className="form_field">
                    <SingleSelect
                      options={notificationTypes}
                      value={values.type}
                      placeholder={t("Select Type")}
                      handleSingleSelectChange={(e) => {
                        setFieldValue("type", e.value);
                      }}
                      className={`${
                        errors.type && touched.type ? "invalid" : ""
                      }`}
                      error={errors?.type}
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="form_field mt_13 mb-0">
                    <div className="d-flex align-items-center gap-3">
                      <InputSwitch
                        checked={values.isScheduled}
                        onChange={(e) => {
                          setFieldValue("isScheduled", !values.isScheduled);
                        }}
                      />
                      <label className="mb-0" htmlFor="isScheduled">
                        {t("Is Scheduled")}
                      </label>
                    </div>
                  </div>
                </Col> */}
                {/* {values.isScheduled && (
                  <Col lg={6}>
                    <div className="form_field mt_13 mb-0">
                      <div className="d-flex align-items-center gap-3">
                        <Calendar
                          id="calendar-12h"
                          value={values.scheduledTime}
                          onChange={(e) =>
                            setFieldValue("scheduledTime", e.value)
                          }
                          showTime
                          hourFormat="12"
                          placeholder={t("Select Scheduled Date & Time")}
                          minDate={new Date()}
                        />
                      </div>
                      <ErrorMessage
                        name={"scheduledTime"}
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>
                )} */}

                <Col lg={12}>
                  <CustomLabel
                    classname="text-danger"
                    htmlFor="count"
                    label={t(
                      "Note: You can use {{name}} as a placeholder for the customer's name in Title or Description Fields, Not Allowed in Broadcast type"
                    )}
                  />
                  <div className="g_end">
                    <button
                      id="submitBtn"
                      className="main_btn"
                      type="submit"
                      disabled={isLoading}
                    >
                      {t("Send")}
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SendNotification;
